<template>
    <div class="wxLoading">
         <!-- <van-popup v-model="show" :overlay="false"> -->
          <div class="box">
             <van-loading size="80px" v-if="show"/>
          </div>
         <!-- </van-popup> -->
    </div>
</template>

<script>
import { Toast } from 'vant'
export default {
    data () {
        return {
            show: true,
            code: 0
        }
    },
    mounted () {
      this.code = this.$route.query.code
      this.$axios.get('/api/DjUser/WxCodeToUserInfo',{
          params:{
              code:this.code
          }
      }).then((res) => {
           
           //this.show = false
          //console.log(res.data)

            if(res.data.type == 1){
              const { Token } = res.data
              // console.log(Token)
              // 存储到ls
              localStorage.setItem('kjToken', Token)
              this.cookieUtil.setCookie('kjToken', Token)
              this.$store.dispatch('getUser', res.data)
              this.$axios.defaults.headers.common['Authorization'] = localStorage.getItem('kjToken') || this.cookieUtil.getCookie('kjToken')
              
              // let backUrl = localStorage.getItem('backUrl') || this.cookieUtil.getCookie('backUrl')
              let loginPath = localStorage.getItem('loginPath') || this.cookieUtil.getCookie('loginPath')

              if (loginPath) { //有登陆前的路径
                // if(backUrl){
                //   window.location.href = backUrl
                // }else{
                  localStorage.removeItem('loginPath')
                  this.cookieUtil.delCookie('loginPath')
                  let path = loginPath
                  this.$router.replace(path)
                // }
              }else{
                this.$router.replace("/profile")
              }

            }else{
              Toast('登录失败！');
            }
      })
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.wxLoading
  width 100%
  height 100%
  display flex
  justify-content center
  align-items center
  .box
    width 300px
    height 300px
    position:absolute;
    left:50%;
    top:50%;
    transform:translate(-50%,-50%);
    display flex
    justify-content center
    align-items center
</style>



// WEBPACK FOOTER //
// src/pages/wxLogin/wxLoading.vue